export const CALCULATOR_TEXTS = {
    MAIN_TITLE: (  <>Calcula el costo de traer <br/> tus compras a Colombia</>),
    SUBTITLE:"Selecciona una modalidad",
    SERVICE_TEXTS: {
        SHOPPER: (   <>
            🛒 Cuando haces tus pedidos en la modalidad de <strong>PERSONAL SHOPPER</strong> nos <strong>encargamos de todo</strong>: Encontrar el mejor proveedor, hacer las compras por ti y llevártelas a casa.
          </>),
        LOCKER:(  <>
            📦 Cuando haces pedidos en la modalidad de <strong>CASILLERO</strong> tú haces las compras de los productos y nosotros nos <strong>encargamos únicamente </strong>de llevártelas a casa.
          </>)
    },
    MODAL_TITLES: {
        INSURANCE: ( <>
            Tu seguridad es <br /> nuestra prioridad
        </>),
        HIGH_VALUE: (<>
            <span>Waaaoooo,</span><br />
            <span>$2.000 usd...ishh</span>
        </>)
    },
    MODAL_CONTENTS: {
        INSURANCE: "Por ende, todos los paquetes que superen los $300 USD en su valor comercial declarado o en sumatoria, deberán llevar seguro obligatorio. Enterate acá qué cubre el seguro.",
        HIGH_VALUE: "Debido a que el costo del producto (o la sumatoria de los productos de tu envío) es igual o superior a $2000 USD debemos traerlo bajo una modalidad especial y única. Tú tranqui que te lo llevamos a casa, solo contáctanos y !PAM¡ a tus manos."
    },
    BUTTON_TEXTS: {
        INSURANCE: "Entendido",
        HIGH_VALUE: "CONTÁCTANOS"
    }
};